// Avstemninger opprettet i denne nettleseren, slik at oppretteren kan
// finne tilbake til den hemmelige resultatlenken. Kun lokal lagring –
// serveren kjenner ikke til listen.
const STORAGE_KEY = "vote.mine.v1";
const MAX_ENTRIES = 50;

export interface MyVote {
  voteId: string;
  resultsId: string;
  title: string;
  createdAt: string;
}

function isMyVote(value: unknown): value is MyVote {
  if (typeof value !== "object" || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.voteId === "string" &&
    typeof v.resultsId === "string" &&
    typeof v.title === "string" &&
    typeof v.createdAt === "string"
  );
}

export function listMyVotes(): MyVote[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(isMyVote).slice(0, MAX_ENTRIES);
  } catch {
    return [];
  }
}

export function rememberVote(vote: MyVote): void {
  try {
    const rest = listMyVotes().filter((v) => v.voteId !== vote.voteId);
    const next = [vote, ...rest].slice(0, MAX_ENTRIES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Full eller utilgjengelig lagring skal aldri stoppe opprettelsen.
  }
}

export function forgetVote(voteId: string): void {
  try {
    const next = listMyVotes().filter((v) => v.voteId !== voteId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Ignorer – listen er bare et hjelpemiddel.
  }
}
